<template>
	<div :class="concatenate_bcfm_class" :style="( minimize_ad ) ? 'height: 85px;' : ''">
		<div class="container" :style="( minimize_ad ) ? 'padding:0' : ''">
			<div class="header">
				<h2>
					<post-smtp-img style="margin-bottom: -25px;margin-right: -15px;" class="d-inline-block" :src="plugin_dir_url + 'assets/images/pro-crown.png'" />
					{{ i18n.__( 'Pro Features', 'post-smtp' ) }}
				</h2>
				<p>
					{{ i18n.__( 'Supercharge your Email', 'post-smtp' ) }}
				</p>
			</div>

			<transition
				name="fade"
				enter-active-class="animated slideIn"
			>
				<div v-if="! minimize_ad" class="body">

					<div class="feature-block" v-for="feature in features" :key="feature.title">
						<div v-if="feature.has_container">
							<post-smtp-img :src="plugin_dir_url + 'assets/images/' + feature.img" />
						</div>
						<div class="create-container" v-else>
							<post-smtp-img :src="plugin_dir_url + 'assets/images/' + feature.img" />
						</div>
						<div class="block-content">
							<p v-html="addLineBreak( feature.title )">
							</p>
						</div>
					</div>

				</div>
			</transition>

			<transition
				name="fade"
				enter-active-class="animated slideIn"
			>
				<div
				v-if="! minimize_ad"
				class="footer"
			>
				<post-smtp-button
					type="get-pro"
					:href="click_link"
					target="_blank"
				>
					{{ i18n.__( 'Get Post SMTP Pro', 'post-smtp' ) }} →
				</post-smtp-button>
			</div>
			</transition>

			<div
				class="post-smtp-minimize-ad"
				v-if="minimize_ad"
				@click="minimizeAd"
			>
				<span class="dashicons dashicons-arrow-down-alt2"></span>
			</div>
			<div
				class="post-smtp-minimize-ad"
				v-else
				@click="minimizeAd"
			>
				<span class="dashicons dashicons-arrow-up-alt2"></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'postSmtpProFeatures',
	inject: [ 'i18n' ],

	props: {
		postSmtpAdPosition: {
			type: String,
			default: 'maximize',
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
		is_bcfm: postSmtpNewDashboard.is_bfcm,
		click_link: '',
		features: [
			{
				title: vm.i18n.__( 'Email Scheduling \r\n Quota Management', 'post-smtp' ),
				img: 'pro-schedule-icon.svg',
				has_container: true,
			},
			{
				title: vm.i18n.__( 'Email Report \r\n and Tracking', 'post-smtp' ),
				img: 'pro-reporting-icon.svg',
				has_container: true,
			},
			{
				title: vm.i18n.__( 'Email Log \r\n Attachment', 'post-smtp' ),
				img: 'pro-log-icon.svg',
				has_container: false,
			},
			{
				title: vm.i18n.__( 'SMS \r\n Notification', 'post-smtp' ),
				img: 'pro-sms-icon.svg',
				has_container: false,
			},

			{
				title: vm.i18n.__( 'Auto Resend \r\n Failed Emails', 'post-smtp' ),
				img: 'pro-resend-icon.svg',
				has_container: true,
			},
			{
				title: vm.i18n.__( 'Microsoft 365 / \r\n Office 365', 'post-smtp' ),
				img: 'pro-365-icon.svg',
				has_container: false,
			},
			{
				title: vm.i18n.__( 'Amazon SES \r\n Support', 'post-smtp' ),
				img: 'pro-amazon-icon.svg',
				has_container: false,
			},
			{
				title: vm.i18n.__( 'Zoho Mail \r\n Support', 'post-smtp' ),
				img: 'pro-zoho-icon.svg',
				has_container: false,
			},
		],

		minimize_ad: 'minimize' === vm.postSmtpAdPosition,
	} ),

	methods: {
		addLineBreak( text ) {
			return text.replace( /\r\n/g, '<br>' );
		},

		minimizeAd() {
			this.minimize_ad = ! this.minimize_ad;
			var minimize_maximize = this.minimize_ad ? 'minimize' : 'maximize';

			axios.post( 'minimize-maximize-ad', {
				minimize_maximize: minimize_maximize,
			} )
				.then( response => {
			} );
		},
	},

	computed: {
		concatenate_bcfm_class() {
			return {
				'bcfm': this.is_bcfm,
				'pro-features': true,
			};
		}
	},

	mounted() {
		this.is_bcfm = '1' === this.is_bcfm;

		this.click_link = this.is_bcfm ? 'https://postmansmtp.com/cyber-monday-sale?utm_source=plugin&utm_medium=section_name&utm_campaign=BFCM&utm_id=BFCM_2024' : 'https://postmansmtp.com/pricing/?utm_source=plugin&utm_medium=dashboard_pro_banner&utm_campaign=plugin';
	}
}
</script>

<style scoped>
.pro-features * {
	padding: 0;
	margin: 0;
}

.pro-features {
	position: relative;
	height: 397px;
	background: url( "../images/pro-bg-left.png" ), url( "../images/pro-bg-right.png" ), url( "../images/pro-background.png" ), linear-gradient(180deg, #375CAF 0%, #2C4A8C 100%);
	background-repeat: no-repeat;
	background-position: left bottom, right bottom, 0 0, 0 0;
	background-size: auto, auto, cover, cover;
	border-radius: 4px;
}

.container {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 38px 62px;
	flex-direction: column;
}

.header h2 {
	background: -webkit-linear-gradient(270deg, #F9AA39 0%, #FFDAA5 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 600;
	line-height: 25.83px;
	text-align: center;
}

.d-inline-block {
	display: inline-block;
}

.header p {
	font-family: Poppins;
	font-size: 16px;
	font-weight: 400;
	line-height: 25.83px;
	text-align: center;


	background: -webkit-linear-gradient(270deg, #F9AA39 0%, #FFDAA5 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	margin-left: 83px;
}

.header {
	margin-bottom: 20px;
}
.footer {
	margin-top: 20px;
}

.create-container {
	width: 56px;
	height: 56px;
	background: url( "../images/pro-icon-bg.svg" );
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	display: flex;
	justify-content: center;
	align-items: center;
}

.body {
	display: grid;
	grid-template-columns: auto auto auto auto ;
	width: 100%;
}

.feature-block {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 20px;
}

.block-content {
	margin-left: 20px;

	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	text-align: left;
	color: #E2E9FB;
}

.post-smtp-minimize-ad {
	position: absolute;
	top: 20px;
	right: 24px;

	color: #BAD0FF;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 12px; /* 100% */

	cursor: pointer;
}

.post-smtp-minimize-ad i {
	margin-right: 10px;
}

.bcfm {
	background: url( ../images/bfcm-2024/dashboard-banner-strip.png ), url( "../images/pro-bg-left.png" ), url( "../images/pro-bg-right.png" ), url( "../images/pro-background.png" ), linear-gradient(180deg, #375CAF 0%, #2C4A8C 100%);
	background-repeat: no-repeat;
	background-position: top right, left bottom, right bottom, 0 0, 0 0;
	background-size: auto, auto, auto, cover, cover;
}
</style>